'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');

/**
 * 水平分割条
 */
var HorizontalRule = React.createClass({

  render: function () {

    var style = styleHelper.StyleUtil(this.props).size().base().style;
    var top = (styleHelper.getHeight(this.props) - 3) / 2;
    var divStyle = {
      borderStyle: 'none',
      backgroundColor: styleHelper.getBackgroundColor(this.props),
      width: '100%',
      height: 2,
      boxSizing:'border-box',
      left: 0,
      top: top,
      position: 'absolute'
    };

    return (
      <div style={style}>
        <div style={divStyle}></div>
      </div>);
  }
});

module.exports = HorizontalRule;



// WEBPACK FOOTER //
// ./src/views/Components/HorizontalRule.jsx